// | ------------------------------------------------------------------------
// | Components - Fixed Header
// | ------------------------------------------------------------------------

var header = document.querySelector(".site-header");

if (header) {
  var fixHeader = function () {
    // Find out height of header element
    var headerHeight = header.offsetHeight;

    // Set --header-height custom property
    document.documentElement.style.setProperty(
      "--header-height",
      headerHeight + "px"
    );

    // Add class when scrolling on windows >= 768px
    var windowWidth = document.body.clientWidth;

    // Get scroll position
    let scroll = window.scrollY;

    // Toggle class
    if (scroll > 50) {
      header.classList.add("scrolling");
    } else {
      header.classList.remove("scrolling");
    }
  };

  // Run on scroll/load/resize
  window.addEventListener("scroll", fixHeader, false);
  window.addEventListener("load", fixHeader, false);
  window.addEventListener("resize", fixHeader, false);
}
